// extracted by mini-css-extract-plugin
module.exports = {"header":"sidebar-header_header__2uB6M","img":"sidebar-header_img__Ff1+Z","title":"sidebar-header_title__fTN3j"};